import { JsonProperty, JsonObject } from 'typescript-json-serializer';

@JsonObject()
export class LmBuildingGroup {
  @JsonProperty('Id') id: string;
  @JsonProperty('Name') name: string;
  @JsonProperty('MaxCurrent') maxCurrent: string;
  @JsonProperty('StationGroupCount') stationGroupCount: number;
  @JsonProperty('Status') status: string;
  @JsonProperty('BuildingMeterId') buildingMeterId?: string;
  @JsonProperty('ChargingProfile') chargingProfile: number;
  @JsonProperty('MinCurrent') minCurrent: number;
  @JsonProperty('LoadSheddingMeterId') loadSheddingMeterId?: string;
  @JsonProperty('LoadSheddingMaxCurrent') loadSheddingMaxCurrent: number;
}
